import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("ff_token"));
  const [loading, setLoading] = useState(true);

  const setAuthHeader = useCallback((t) => {
    if (t) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    } else {
      delete axios.defaults.headers.common["Authorization"];
    }
  }, []);

  // On mount, validate stored token
  useEffect(() => {
    const init = async () => {
      if (token) {
        setAuthHeader(token);
        try {
          const res = await axios.get(`${BACKEND_URL}/api/auth/me`);
          setUser(res.data);
        } catch {
          localStorage.removeItem("ff_token");
          setToken(null);
          setAuthHeader(null);
        }
      }
      setLoading(false);
    };
    init();
  }, [token, setAuthHeader]);

  const login = async (email, password) => {
    const res = await axios.post(`${BACKEND_URL}/api/auth/login`, { email, password });
    const { token: t, user: u } = res.data;
    localStorage.setItem("ff_token", t);
    setToken(t);
    setAuthHeader(t);
    setUser(u);
    return u;
  };

  const register = async (email, password, name) => {
    const res = await axios.post(`${BACKEND_URL}/api/auth/register`, { email, password, name });
    const { token: t, user: u } = res.data;
    localStorage.setItem("ff_token", t);
    setToken(t);
    setAuthHeader(t);
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem("ff_token");
    setToken(null);
    setAuthHeader(null);
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/auth/me`);
      setUser(res.data);
    } catch {
      // ignore
    }
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, refreshUser, isPatron: user?.tier === "patron" }}>
      {children}
    </AuthContext.Provider>
  );
};
